"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require("@shopify/theme-sections");

var _limelight = require("@dotdev/limelight");

var _limelight2 = _interopRequireDefault(_limelight);

var _ajaxQueue = require("@dotdev/ajax-queue");

var _ajaxQueue2 = _interopRequireDefault(_ajaxQueue);

var _handlebarsMin = require("handlebars/dist/handlebars.min.js");

var _handlebarsMin2 = _interopRequireDefault(_handlebarsMin);

var _themeCurrency = require("@shopify/theme-currency");

require("../../styles/sections/theme-header.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)("theme-header", {
  onLoad: function onLoad() {

    if (this.container.hasAttribute('data-js-off')) {
      return false;
    }

    // Mega menu subnav
    var menuSelectors = this.container.querySelectorAll('[data-trigger="mega-menu"]');
    this.menuItems = [];

    menuSelectors.forEach(function (trigger, index) {
      var is_visible = false;

      if (index == 0) {
        is_visible = true;
      }
      this.menuItems[index] = new _limelight2.default("" + trigger.dataset.target, {
        visible: is_visible,
        hover: true,
        click: false,
        triggerClass: "active",
        group: "menuItem",
        beforeShowCallback: function beforeShowCallback(element, elements) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = Object.keys(elements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var key = _step.value;

              if (elements[key].settings.group === "menuItem") {
                elements[key].hide();
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        },
        showCallback: function showCallback(element, elements) {
          var target = document.querySelector(element.target);
          target.parentNode.style.minHeight = target.children[0].offsetHeight + 46 + "px";
        }
      });
    }.bind(this));

    // Search trigger
    var PopupSearch = new _limelight2.default("#PopupSearch", {
      beforeShowCallback: function beforeShowCallback() {
        Velocity(document.body, "scroll", {
          offset: 0,
          duration: 400,
          easing: "ease-in-out"
        });
      },
      bodyClass: "active-search"
    });

    // Initialize auto suggestion feature
    this.searchQueue = new _ajaxQueue2.default();
    this.psudoSearchField = document.querySelector("[data-search-field]");
    this.searchField = document.querySelector("[data-search-results]");
    this.searchResponse = document.querySelector("[data-search-response]");
    this.searchTemplate = document.querySelector("[data-search-template]");
    var typingTimeout = void 0;

    var ajaxSearch = function (event) {
      var _this = this;

      clearTimeout(typingTimeout);
      var query = this.searchField.value;
      if (query) {
        if (query !== this.oldQuery) {
          this.oldQuery = query;
          typingTimeout = setTimeout(function () {
            var milliseconds = new Date().getTime();
            var url = "https://services.mybcapps.com/bc-sf-filter/search/suggest?q=" + query + "&shop=mineral-fusion-us.myshopify.com&t=" + milliseconds;
            var request = {
              url: url,
              success: function success(response) {
                var json = JSON.parse(response);
                var filteredProducts = json.products.filter(function (product) {
                  return !product.tags.includes("freegift");
                });
                var filteredCollections = json.collections.filter(function (product) {
                  return !product.handle.includes("free");
                });
                buildSearchSuggestionResults(Object.assign({}, json, {
                  collections: filteredCollections,
                  products: filteredProducts,
                  total_product: filteredProducts.length
                }));
                ajaxSearch();
              }.bind(_this)
            };
            _this.searchQueue.add(request);
          }, 150);
        }
      } else {
        this.searchResponse.innerHTML = "";
        this.oldQuery = query;
      }
    }.bind(this);

    var buildSearchSuggestionResults = function (data) {
      var results = data;
      var pages = results.pages;
      results.articles = [];

      for (var index = 0; index < pages.length; index++) {
        var item = pages[index];

        if (item.url.indexOf("/blogs/") > -1) {
          results.articles.push(item);
        }
      }

      for (var index = 0; index < results.articles.length; index++) {
        var _item = results.articles[index];
        var position = results.pages.indexOf(_item);

        if (position > -1) {
          results.pages.splice(position, 1);
        }
      }

      var searchSuggestionsTemplateHandlebars = _handlebarsMin2.default.compile(this.searchTemplate.innerHTML);

      if (this.searchResponse) {
        this.searchResponse.innerHTML = searchSuggestionsTemplateHandlebars(results);

        var currencyTrigger = new Event("currency:convert");
        document.dispatchEvent(currencyTrigger);
      }
    }.bind(this);

    var focusResultsPane = function focusResultsPane() {
      PopupSearch.show();
    };

    this.searchField.addEventListener("input", ajaxSearch);
    this.searchField.addEventListener("focus", ajaxSearch);
    this.psudoSearchField.addEventListener("input", focusResultsPane);
    this.psudoSearchField.addEventListener("focus", focusResultsPane);

    // Header size
    var updateHeaderSize = function updateHeaderSize() {
      var header = document.querySelector(".theme-header");
      var headerSpacing = document.querySelector("[data-header-spacing]");
      var headerCollapse = document.querySelector("[data-header-collapse]");
      var headerHide = document.querySelector("[data-header-hide]");
      var headerOffsetTop = document.querySelector("[data-header-offset-top]");
      header.dataset.offset = -1;
      headerSpacing.style.paddingTop = 0;
      header.classList.remove("stuck");

      var headerOffset = header.offsetTop;

      if (headerOffsetTop) {
        headerOffsetTop.style.height = headerOffset + "px";
      }

      if (headerHide.offsetParent !== null) {
        headerOffset = header.offsetTop + headerCollapse.offsetHeight;
      }

      header.dataset.offset = headerOffset;
      header.dataset.height = header.offsetHeight;

      updateHeaderState();
    };

    var updateHeaderState = function updateHeaderState() {
      var header = document.querySelector(".theme-header");
      var headerSpacing = document.querySelector("[data-header-spacing]");
      var scrollY = window.scrollY;

      if (header.dataset.offset >= 0) {
        if (scrollY >= header.dataset.offset) {
          header.classList.add("stuck");
          headerSpacing.style.paddingTop = header.dataset.height + "px";
        } else {
          header.classList.remove("stuck");
          headerSpacing.style.paddingTop = 0;
        }
      }
    };

    document.addEventListener("scroll", updateHeaderState);
    document.addEventListener("announcement:hide", updateHeaderSize);
    window.addEventListener("resize", updateHeaderSize);
    window.addEventListener("orientationchange", updateHeaderSize);
    updateHeaderSize();

    // GTM: quiz view tracking event
    function PageViewTracking() {
      var currentMainSliderIndex = $(".question-slider-wrapper").find(".slick-current").data("slick-index");
      var currentQuestionSliderIndex = $(".slider-question-wrapper .slick-current").length ? $(".slider-question-wrapper").find(".slick-current").data("slick-index") : 0;
      if (currentMainSliderIndex == 0) {
        console.log("event: quizStep", "step: 1");
        dataLayer.push({ event: "quizStep", step: "1" });
      } else if (currentMainSliderIndex == 1) {
        console.log("event: quizStep", "step: 2");
        dataLayer.push({ event: "quizStep", step: "2" });
      } else if (currentMainSliderIndex == 2) {
        console.log("event: quizStep", "step: 3");
        dataLayer.push({ event: "quizStep", step: "3" });
      } else if (currentMainSliderIndex == 3) {
        console.log("event: quizStep", "step: 4");
        dataLayer.push({ event: "quizStep", step: "4" });
      } else if (currentMainSliderIndex == 4) {
        if (currentQuestionSliderIndex == 0) {
          console.log("event: quizStep", "step: 5");
          dataLayer.push({ event: "quizStep", step: "5" });
        } else {
          console.log("event: quizStep", "step: review");
          dataLayer.push({ event: "quizStep", step: "review" });
        }
      }
    }

    // Quiz popup
    if ($("#PopupQuiz").length) {
      var QuizPopup = new _limelight2.default("#PopupQuiz", {
        bodyClass: "active-popup"
      });

      $(document).on("click", "[data-quiz-popup]", function () {
        if (window.location.pathname == "/") {
          QuizPopup.show();

          // GTM: quiz open tracking event, triggering when the popup opens
          console.log("event: gtm-quiz-open");
          dataLayer.push({ event: "gtm-quiz-open" });

          // GTM: quiz view tracking event, triggering first time when the popup opens
          PageViewTracking();
        } else {
          window.location = "/#skincare-quiz";
        }
      });
    }

    $(document).ready(function () {
      if (window.location.hash.indexOf("skincare-quiz") !== -1 && $("#PopupQuiz").length) {
        var _QuizPopup = new _limelight2.default("#PopupQuiz", {
          bodyClass: "active-popup"
        });

        window.location.hash = "";
        _QuizPopup.show();

        // GTM: quiz open tracking event, triggering when the popup opens
        console.log("event: gtm-quiz-open");
        dataLayer.push({ event: "gtm-quiz-open" });

        // GTM: quiz view tracking event, triggering first time when the popup opens
        PageViewTracking();
      }
    });
  }
});